import { apiCall } from "./servicesCall";

export const FITBYTEAI_SERVICES = {
  getUsers(data) {
    return apiCall("/fitbyteai/users", data);
  },
};
